import React, { ReactNode, useState } from 'react';
import { Content } from 'antd/es/layout/layout';
import { Col, Collapse, Row } from 'antd';
import { ChevronDown, ChevronUp } from 'assets/svg';
import { CollapseProps } from 'antd/lib';
import './css/customCollapse.css';
export interface IProps {
  children: ReactNode;
  active?: boolean;
  title: string;
  space?: any;
  border?: any;
  onchange?: () => any;
}

const { Panel } = Collapse;
const DropdownComponent = ({
  title,
  children,
  active,
  space,
  border,
  onchange,
}: IProps) => {
  return (
    // <Collapse
    //   defaultActiveKey={['1']}
    //   className="p-0"
    //   expandIconPosition="end"
    //   ghost
    //   expandIcon={({ isActive }) =>
    //     isActive ? <ChevronUp /> : <ChevronDown />
    //   }
    //   size="middle"
    //   items={items}
    // />

    <Collapse
      className="bg-white"
      defaultActiveKey={active == undefined || active === true ? ['1'] : []}
      expandIconPosition="end"
      ghost
      expandIcon={({ isActive }) =>
        isActive ? <ChevronUp /> : <ChevronDown />
      }
      onChange={onchange}
    >
      <Panel
        header={<p className="text-base font-bold text-primary-50">{title}</p>}
        key="1"
        className=""
      >
        {children}
      </Panel>
    </Collapse>
  );
};

export default DropdownComponent;
